import { colors, ModalForm } from 'modules/app/styles'
import moment from 'moment'
import { CurrentPlanInfo, PlanSelector, ResumePlanButton } from './styles'
import { ReactComponent as RightArrowIcon } from 'assets/images/icons/right_arrow.svg'
import { ReactComponent as NoInvoiceIllustrator } from 'assets/images/no_invoice_illustration.svg'
import { connect } from 'react-redux'
import { toggleCardModal_action, toggleCheckoutModal_action, toggleResumePlanModal_action, changeTab_action } from 'store/actions'
import { PageLoader } from 'utils/storageUtils'
import InvoicesList from './InvoicesList'
import { IntegrationBox } from 'modules/settings/styles'

const Subscribed = (props) => {
  const { invoices, invoice_fetching } = props
  return (
    <ModalForm className='h-100 d-flex flex-wrap flex-md-nowrap'>
      {!props.plan_loading && props.monthly.id && props.yearly.id && (
        <>
          <CurrentPlanInfo className='subscribed'>
            <div className='title'>Billing</div>
            <div className='my-4'>
              <div className='info-label'>Current Plan</div>
              <div className='plan-name' style={{ color: colors['main-blue'] }}>
                PRO
              </div>
            </div>
            <div className='my-4'>
              <div className='info-label mb-1 text-capitalize'>Renewal Date</div>
              {!props.subscription.cancel_at_period_end && (
                <div className='info-value'>
                  {moment
                    .utc(new Date(props.subscription.current_period_end * 1000))
                    .local()
                    .format('ll')}
                </div>
              )}
              {/* Cancelled till period end */}
              {props.subscription.cancel_at_period_end && (
                <div className='info-value text-danger'>
                  <span className='font-weight-600'>Cancelled.</span> You can still
                  <br />
                  use it until{' '}
                  {moment
                    .utc(new Date(props.subscription.current_period_end * 1000))
                    .local()
                    .format('ll')}
                </div>
              )}
            </div>

            {props.membership && props.membership.invite_status === 'owned' && (
              <>
                <div className='my-4'>
                  <div className='info-label mb-1 text-capitalize'>{props.subscription.plan.interval}ly Payment</div>
                  <div className='info-value'>
                    ${props.subscription.plan.amount / 100} ({props.active_users.length} {props.active_users.length === 1 ? 'member' : 'members'})
                  </div>
                </div>
                <div className='mt-auto'>
                  {!props.subscription.cancel_at_period_end && (
                    <ResumePlanButton className='black btn-block mb-3' onClick={() => props.toggleCheckoutModal(true)}>
                      Manage Plan
                    </ResumePlanButton>
                  )}
                  {props.subscription.cancel_at_period_end && (
                    <ResumePlanButton className='black btn-block mb-3' onClick={() => props.toggleResumePlanModal(true)}>
                      Resume Plan <RightArrowIcon />
                    </ResumePlanButton>
                  )}
                  <ResumePlanButton className='gray  btn-block shadow-none' onClick={() => props.toggleCardModal(true)}>
                    {props.card.id ? `Update Credit Card` : 'Add Credit Card'}
                  </ResumePlanButton>
                </div>
              </>
            )}
          </CurrentPlanInfo>
          <PlanSelector style={{ maxHeight: '90vh', overflow: 'auto' }}>
            {/* ADMIN */}
            {props.membership && props.membership.invite_status === 'owned' && (
              <>
                {invoice_fetching && (
                  <div className='text-center my-auto'>
                    <PageLoader />
                  </div>
                )}
                {!invoice_fetching && invoices.length === 0 && (
                  <div className='text-center my-auto'>
                    <NoInvoiceIllustrator />
                    <p>No Invoices Yet...</p>
                  </div>
                )}
                {!invoice_fetching && invoices.length > 0 && <InvoicesList invoices={invoices} stripe_customer={props.stripe_customer} />}
              </>
            )}
            {/* MEMBER */}
            {props.membership && props.membership.invite_status !== 'owned' && (
              <IntegrationBox className='my-auto' style={{ width: 400, height: 'auto' }}>
                <div className='content'>
                  <div>
                    Sorry, you don't have permission to view this page.
                    <br />
                    You can contact the{' '}
                    <a
                      href='/'
                      className='font-weight-600'
                      onClick={(e) => {
                        e.preventDefault()
                        props.changeTab('team_members')
                      }}>
                      owner
                    </a>{' '}
                    to upgrade the plan 🙂
                  </div>
                </div>
              </IntegrationBox>
            )}
          </PlanSelector>
        </>
      )}
    </ModalForm>
  )
}

const mapStateToProps = (state) => ({
  membership: state.auth.user.membership,
  isSubmittingSubscription: state.subscription.isSubmittingSubscription,
  is_subscribed: state.subscription.is_subscribed,
  subscription: state.subscription.subscription,
  invoices: state.subscription.invoices,
  invoice_fetching: state.subscription.invoice_fetching,
  stripe_customer: state.company.company.stripe_customer
})

const mapDispatchToProps = (dispatch) => ({
  toggleCardModal: (value) => dispatch(toggleCardModal_action(value)),
  toggleResumePlanModal: (value) => dispatch(toggleResumePlanModal_action(value)),
  changeTab: (value) => dispatch(changeTab_action(value)),
  toggleCheckoutModal: (value) => dispatch(toggleCheckoutModal_action(value))
})

export default connect(mapStateToProps, mapDispatchToProps)(Subscribed)
